import { Link, useLocation} from "react-router-dom";
import Player from "../components/Player";
import TextLink from '../components/TextLink';
import Button from '../components/Button';
import { motion } from "framer-motion"

function Header(props) {
    const location = useLocation();
    return (
      <section className="hero is-fullheight pt-4 pl-4 pb-4 pr-4 is-fixed header">
        <motion.div className="hero-head" {...props.framer.slideInfromAbove}>
          <div className='block'>
            <Link to="/">
              <img className="image is-fullwidth logo" alt="Drifting" onClick={props.onClick.home} src={"./img/logo_black.svg"} />
            </Link>
          </div>
          <div className="columns is-mobile">
            <div className="column is-4 ">
              <Link to="/about">
                <Button onClick={props.onClick.project} selected={location.pathname==="/about"}>About</Button>
              </Link>
            </div>
            <div className="column is-4">
              <Link to="/crawler">
                <Button onClick={props.onClick.crawler} selected={location.pathname==="/crawler"}>Crawler</Button>
              </Link>
            </div>
            <div className="column is-4">
              <Button onClick={props.onClick.theater}>Theater</Button>
            </div>
            {/* <div className="column is-3">
              <Link to="/crawler">
                <Button onClick={props.onClick.crawler} selected={location.pathname==="/utility"}>Utility</Button>
              </Link>
            </div> */}
          </div>
        </motion.div>
        <motion.div className="hero-foot" {...props.framer.slideInfromBelow}>
          <div className="columns is-gapless is-size-3 is-hidden-mobile is-hidden-tablet-only is-paddingless is-serif">
            <div className="column is-5 is-size-4">
              A new generative art series by Simon De Mai (updates on <TextLink href="https://twitter.com/simondemai">Twitter</TextLink>).
            </div>
            <div className="column is-2"></div>
            <div className="column is-5 is-size-4">
              The 360 pieces have been minted. Explore the collection on <TextLink href="https://www.artblocks.io/project/286">ArtBlocks</TextLink>.
            </div>
          </div>
          {/* <Player /> */}
        </motion.div>
      </section>
    )
  }

export default Header;